import { Input } from '@progress/kendo-react-inputs'
import styled from 'styled-components'

export const Container = styled.div`
    gap: 16px;
    padding: 8px;
    display: flex;
    flex-direction: column;
`

export const UploadDocument = styled.div`
    display: flex;
    height: 12rem;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    border: 1px dashed #777777;
`

export const UploadButton = styled.button`
    padding: 8px 16px;
    border-radius: 4px;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
    justify-content: center;
    border: 1px solid #707070;
    background: #EAEAEA;
`

export const TableData = styled.td`
    font-weight: 600;
    font-size: 16px;
    color: #333333;
`
export const IconWrapper = styled.div`
    max-width: 24px;
    max-height: 24px;
    min-width: 24px;
    min-height: 24px;
`

export const TransparentInput = styled(Input)`
    border: none;
    outline: none;
    box-shadow: none;
    color: white;
    background: transparent;
    :focus, :hover{
        border: none;
        outline: none;
        box-shadow: none;
        color: white;
        background: transparent;
    }
`

export const WrappreFilter = styled.div`
    gap: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`